import { API } from 'Constants/options';
import { BASE_URL } from 'Constants/config';

class WebService {
  static sharedInstance;
  static getSharedInstance = () => {
    if (WebService.sharedInstance) {
      return WebService.sharedInstance;
    }
    WebService.sharedInstance = new WebService();
    return WebService.sharedInstance;
  };

  callWebservice = ({
    method,
    path,
    data, 
    optionalHeaders,
    shouldStringify = true,
  }) =>
    new Promise((resolve, reject) => {
      const url = `${BASE_URL}${API}${path}`;
      let headers = { 'Content-Type': 'application/json' };

      if (optionalHeaders) {
        headers = {
          ...headers,
          ...optionalHeaders,
        };
      }

      fetch(url, {
        method,
        headers,
        body: shouldStringify ? JSON.stringify(data) : data,
      })
        .then((response) => {
          switch (response.status) {
            case 401:
              response.json().then((message) => reject(message.custom_code));
              return;
            case 409:
              response.json().then((message) => reject(message.custom_code));
              return;
            case 200:
              resolve(response.json());
              return;
            case 204:
              resolve();
              return;
            default:
              response.json().then((message) => reject(message.custom_code));
              return;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

export default WebService;
